import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { endpoints } from '../../core/constants/endpoints';
import { EnumContexto, ITopicsResponse, ITopicsResponseRaw, toTopicsResponse } from '../interfaces/topic.interface';

@Injectable({ providedIn: 'root' })
export class TopicsApi {

  private readonly url = `${environment.ceppemAiApi}/${endpoints.ceppemAi.topics}`;

  constructor(private http: HttpClient) {}

  fetchTopics(contexto?: EnumContexto): Observable<ITopicsResponse> {
    const url = contexto ? `${this.url}?contexto=${contexto}` : this.url;
    return this.http.get<ITopicsResponseRaw>(url).pipe(map(toTopicsResponse));
  }

  fetchTopicsByInformation(informationIds: string[]): Observable<ITopicsResponse> {
    const params = informationIds.reduce(
      (acc, id) => acc.append('information_ids', id),
      new HttpParams()
    );
    return this.http.get<ITopicsResponseRaw>(this.url, { params }).pipe(map(toTopicsResponse));
  }
}
